export const timeTypes = [
  {text: 'Personalizado', key: 'custom'},
  {text: 'Siempre', key: 'always'},
  {text: 'Al menos 15 minutos', key: 'atLeast'}
]
export const dateTypes = [
  {text: 'Personalizado', key: 'custom'},
  {text: 'Dias de la semana', key: 'daysOfWeek'},
  {text: 'Dias de un mes', key: 'daysOfMonth'},
  {text: 'Indeterminado con fecha de inicio', key: 'indeterminated'}
]
export const dateTypesMap = new Map([
  ['monday', 'Lunes'],
  ['tuesday', 'Martes'],
  ['wednesday', 'Miercoles'],
  ['thursday', 'Jueves'],
  ['friday', 'Viernes'],
  ['saturday', 'Sabado'],
  ['sunday', 'Domingo']
])

export const timeTypesMap = new Map([
  ['custom', {text: 'Personalizado', key: 'custom'}],
  ['always', {text: 'Siempre', key: 'always'}],
  ['atLeast', {text: 'Al menos 15 minutos', key: 'atLeast'}]
])

export const daysList = [
  {text: 'Lunes', value: 'monday'},
  {text: 'Martes', value: 'tuesday'},
  {text: 'Miercoles', value: 'wednesday'},
  {text: 'Jueves', value: 'thursday'},
  {text: 'Viernes', value: 'friday'},
  {text: 'Sabado', value: 'saturday'},
  {text: 'Domingo', value: 'sunday'}
]

export const zoneTypes = [
  ['firefightersDivision', 'Bomberos'],
  ['commune', 'Comuna'],
  ['quadrant', 'Cuadrante'],
  ['neighborhood', 'Barrio'],
  ['fence', 'Cerca'],
  ['policeDistrict', 'Distrito'],
  ['policeStation', 'Estación'],
  ['municipality', 'Municipio']
]

export default {
  timeTypes,
  dateTypes,
  daysList,
  zoneTypes,
  dateTypesMap,
  timeTypesMap
}



// WEBPACK FOOTER //
// ./src/utils/scheduleHelpers.js